import styled from 'styled-components';
import MUIPagination from '@material-ui/lab/Pagination';


export const Pagination = styled(MUIPagination)`
  ${({
    theme: {
      colors,
      typography,
      palette,
      breakpoints,
      transitions: { easing, duration },
    },
  }) => `
    margin: 30px 0;
    padding-top: 30px;

    display: flex;
    justify-content: center;    

    li {
      background: ${colors.greys.greys2};
      margin: 0 3px;
    }    

 
    ${breakpoints.up('md')} {
      .MuiPagination-ul {
        width: 80%;
         flex-wrap: nowrap;
         li {
          
           &:first-child {
            background: none;
             flex-basis: 100%;
             display: flex;
             justify-content: flex-start;
             align-items: center;

          >  button {
            width: 120px;
            border: 1px solid #003C3B;
            border-radius: 3px;
              svg {
                display: none;
              }
            }
             > button::before {
              background-color: #003C3B;
              content: url(/svg/ArrowLeft.svg);
              mask: url(/svg/ArrowLeft.svg) no-repeat center
             }
             >button::after {
              padding-left: 0.5rem;
              color: #003C3B;
              content: 'Previous';
             }
             &::hover {
              background-color: #000;
             }
           }
           &:last-child {
            background: none;
             flex-basis: 100%;
             display: flex;
             justify-content: flex-end;
             align-items: center;

             
             >  button {    
              width: 120px;
              border: 1px solid #003C3B;
              border-radius: 3px;
              svg {
                display: none;
              }
            }
             >button::before {
               margin-right: 10px;
               color: #003C3B;
               content: 'Next';
             }
             >button::after {
              background-color: #003C3B;
              content: url(/svg/ArrowRight.svg);
              mask: url(/svg/ArrowRight.svg) no-repeat center
             }
             &::hover {
              background-color: #000;
             }
           }
           
         }
        }
       }
       
     

    .MuiPaginationItem-root {



      
      font-size: ${typography.body1.fontSize};
      font-weight: 500;
      margin: 0;
      border: 1px solid transparent;
      border-radius: 0;
      background-color: ${colors.greys.greys3};
      transition: ${duration.short}ms ${easing.easeInOut};

      &:hover {
        color: ${palette.common.white};
        background-color: ${palette.action.hover};

        .MuiPaginationItem-icon {
          color: ${palette.common.white};
        }
      }

      &.Mui-selected {
        color: ${palette.text.primary};
        background-color: ${palette.common.white};
        border-color: ${palette.primary.main};
      }

      &.Mui-disabled {
				cursor: not-allowed;

        .MuiPaginationItem-icon {
          color: ${palette.primary.main};
        }
      }

			&.MuiPaginationItem-ellipsis {
				&:hover {
					color: ${palette.text.primary};
					background-color: ${colors.greys.greys3};
					cursor: not-allowed;
				}
			}
    }    

    .MuiPaginationItem-sizeLarge {
      width: 48px;
      height: 48px;
      line-height: 48px;
    }

    .MuiPaginationItem-icon {
  
      color: ${palette.secondary.main}
    }
  `}
`;
